module.exports = __webpack_public_path__ + "img/a-ziyuan11.087dd72a.png";